<div class="image">
  <img src="{getSrc}" />
</div>
